const height = {
	requestsListFinal: "calc(100vh - 386px)",
	requestsListForAdmin: "calc(100vh - 386px)",
	requestsListFinalAdvanced: "calc(100vh - 393px)",
	requestsList: {
		desktop: "calc(100vh - 288px)",
		mobile: "calc(100vh - 255px)",
	},
	users: "calc(100vh - 302px)",
	products: "calc(100vh - 302px)",
	subDivisionCategories: "calc(100vh - 302px)",
	productCategories: "calc(100vh - 302px)",
	measurements: "calc(100vh - 302px)",
} as const;

export default height;
